/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, RequestResult } from '#shared/api/client'
import type { GetPasskeyAdditionOptionsOptions, GetPasskeyAdditionOptionsResponses } from '../models/GetPasskeyAdditionOptions'
import { client } from '#shared/api/client'

/**
 * @summary `POST /api/passkeys/register-options`, no body: the challenge for another
 * passkey of the signed-in account, its existing credentials excluded.
 * {@link /api/passkeys/register-options}
 */
export function getPasskeyAdditionOptions<ThrowOnError extends boolean = true>(options: Options<GetPasskeyAdditionOptionsOptions, ThrowOnError> = {}): Promise<RequestResult<GetPasskeyAdditionOptionsResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return request({ method: 'POST', url: '/api/passkeys/register-options', security: [{ type: 'apiKey', name: 'cas_session', in: 'cookie' }], ...config, throwOnError: config.throwOnError ?? true }) as Promise<RequestResult<GetPasskeyAdditionOptionsResponses, ThrowOnError>>
}
